export default "__VITE_ASSET__31r0XeJA__"